<template>
	<span v-if="enableReEntryBtn" class="scan-rfid">
		<button class="better-mobile-btn" :class="{ 'is-scanning': isScanning, 'grey-background': rfid !== '' && !isScanning } " v-on:click="startScanning">
			<CheckIcon v-if="rfid !== '' && !isScanning"/>
			<HandIcon v-else/>
			{{ btnLabel }}
		</button>
	</span>
</template>

<script>
/*
	RFID is emitted as a Low to High 7 byte Hex string (14 chars) with the colons stripped.
 */

import HandIcon from "./icons_svg/HandIcon.vue";
import CheckIcon from "./icons_svg/CheckIcon.vue";

const DEFAULT_BTN_LABEL = 'SCAN RE-ENTRY';
const IS_SCANNING_BTN_LABEL = 'TAP RFID';

export default {
	name: 'ScanReentryButton',
	inject: ['rfidService'],
	components: {
		CheckIcon,
		HandIcon
	},
	data() {
		return {
			shouldEmit: false,
			isScanning: false,
			rfid: '',
			btnLabel: DEFAULT_BTN_LABEL,
		}
	},
	computed: {
		enableReEntryBtn() {
			return process.env.VUE_APP_ENABLE_REENTRY === "true" && this.rfidService.doesDeviceHaveNFC()
		}
	},
	methods: {
		async startScanning() {
			this.isScanning = true
			this.btnLabel = IS_SCANNING_BTN_LABEL

			this.rfidService.once('rfid:scanned', ({rfid}) => {
				if(this.isScanning) {
					this.$emit('scanned', rfid);
					this.resetState()
				}
			})
		},
		// Resets the state after rfid read or error
		resetState() {
			this.isScanning = false;
			this.btnLabel = DEFAULT_BTN_LABEL;
		},
	},
}
</script>

<style scoped>
.scan-rfid .loading-message {
	animation: pulse 1.65s infinite linear;
}

.is-scanning {
	background-color: #ff8d3f !important;
}

.grey-background {
	background: #666 !important;
}
</style>